import { createTheme } from "@mui/material/styles";

const primary = "#066EAC";
const primaryLight = "#1BA6B626";
const primaryDark = "#0071BA";

const cardBackground = "#f4f4f4";
const cardBorder = "#D8D8D8";

const titleColor = "#0071ba";

export const theme = createTheme({
  palette: {
    primary: {
      main: primary,
      light: primaryLight,
      dark: primaryDark,
    },
    primaryLight: {
      main: primaryLight,
    },
    primaryDark: {
      main: primaryDark,
    },
    titleColor: {
      main: titleColor,
    },
  },

  typography: {
    title: {
      color: titleColor,
      fontSize: "36px",
      lineHeight: "48px",
    },

    subtitle: {
      color: titleColor,
      fontSize: "24px",
      lineHeight: "normal",
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          width: "100%",
          boxShadow: "none",
          backgroundColor: cardBackground,
          borderRadius: "1rem",
          border: `1px solid ${cardBorder}`,
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiSelect-select": {
            padding: "6px 8px",
          },
          /*  padding: "16px 8px 32px", */
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "&.smaller .MuiInputBase-input": {
            padding: "6px 8px",
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          height: "40px",
          padding: "10px 24px",
          borderRadius: "100px",
          cursor: "pointer",
          "&.MuiChip-colorPrimary.MuiChip-filled": {
            backgroundColor: titleColor,
            "& .MuiChip-label": {
              padding: 0,
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "20px",
              color: "#fff",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(29, 27, 32, 0.12)",
              "& .MuiChip-label": {
                padding: 0,
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "20px",
                color: "#1D1B20",
              },
            },
          },

          "&.MuiChip-colorPrimary.MuiChip-outlined": {
            /* backgroundColor: titleColor, */
            "& .MuiChip-label": {
              padding: 0,
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "20px",
              /* color: "#fff", */
            },
          },
        },
      },
    },
  },
});
